export default __webpack_public_path__ + "static/media/Formular-Bold.14c11b56.woff2";